import React, { useEffect, useState } from 'react';
import { Modal } from './ds';

const SessionTimeoutModal = ({
  isOpen,
  onStayLoggedIn,
  onLogout,
  timeRemaining,
  warningType = 'app',
  brokerName,
}) => {
  const [displayTime, setDisplayTime] = useState(timeRemaining);

  // Update local display time every second for smooth countdown
  useEffect(() => {
    setDisplayTime(timeRemaining);
    const timer = setInterval(() => {
      setDisplayTime((prev) => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [timeRemaining, isOpen]);

  if (!isOpen) return null;

  // Format time as MM:SS
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => {}}
      dismissible={false} //--> forced choice: no X / ESC / backdrop close
      size="sm"
      title={
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--warning)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
            <path d="M12 9v4M12 17h.01" />
          </svg>
          {warningType === 'broker' ? 'Broker Session Expiring' : 'Session Expiring'}
        </span>
      }
      footer={
        <>
          <button type="button" onClick={onLogout} className="btn btn-secondary">
            Logout
          </button>
          <button type="button" onClick={onStayLoggedIn} className="btn btn-primary" autoFocus>
            Stay Logged In
          </button>
        </>
      }
    >
      <p className="ds-body" style={{ margin: '0 0 12px' }}>
        {warningType === 'broker' ? (
          <>
            Your session for <strong>{brokerName || 'Broker Account'}</strong> will expire in{' '}
            <strong>{formatTime(displayTime)}</strong>. Please save your work or extend the session.
          </>
        ) : (
          <>
            Your session will expire in <strong>{formatTime(displayTime)}</strong>. For security
            reasons, you will be automatically logged out.
          </>
        )}
      </p>
      <p className="ds-body" style={{ margin: '0 0 12px' }}>Do you want to stay logged in?</p>
      <div style={{ width: '100%', height: 4, background: 'var(--bg-3)', borderRadius: 2, overflow: 'hidden' }}>
        <div
          style={{
            width: `${Math.max(0, Math.min(100, (displayTime / 60) * 100))}%`,
            height: '100%',
            background: 'var(--warning)',
            transition: 'width 1s linear',
          }}
        />
      </div>
    </Modal>
  );
};

export default SessionTimeoutModal;
